import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-tour-summary-list',
  templateUrl: './tour-summary-list.component.html',
  styleUrls: ['./tour-summary-list.component.css']
})
export class TourSummaryListComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
